<template>
  <div
    class="ovg-upload__drop"
    role="button"
    tabindex="0"
    @dragover.prevent
    @drop.prevent="onDrop"
    @click="openPicker"
    @keydown.enter.prevent="openPicker"
  >
    <input
      id="filePart"
      ref="file"
      type="file"
      class="ovg-upload__input"
      accept=".pdf,.png,.jpg,.jpeg,.tiff,.gif,image/*,application/pdf"
      @change="handleFileUpload"
      @click.stop
    />
    <font-awesome-icon class="ovg-upload__icon" icon="cloud-upload-alt" />
    <p class="ovg-upload__text">Sube o arrastra tu documento aquí.</p>
    <span class="ovg-btn ovg-btn--primary ovg-btn--sm">
      Seleccionar desde tu equipo
    </span>
    <p v-if="file" class="ovg-upload__filename">{{ file.name }}</p>
    <p class="ovg-upload__hint">
      Formatos aceptados: JPG, PNG o PDF. Peso máximo: 5 MB.
    </p>
  </div>
</template>

<script>
const MAX_BYTES = 5 * 1024 * 1024
const ALLOWED_TYPES = [
  'image/jpeg',
  'image/png',
  'application/pdf',
  'image/tiff',
  'image/gif',
]

export default {
  name: 'UploadFilePreIngreso',
  props: ['setBoleta', 'boleta'],
  data() {
    return {
      file: this.boleta || '',
    }
  },
  watch: {
    boleta(val) {
      this.file = val || ''
    },
  },
  methods: {
    openPicker() {
      this.$refs.file.click()
    },
    applyFile(candidate) {
      if (!candidate) return
      if (!ALLOWED_TYPES.includes(candidate.type)) {
        this.$bvToast.toast('Solo se permiten archivos .jpg, .png, .pdf ', {
          variant: 'danger',
        })
        return
      }
      if (candidate.size > MAX_BYTES) {
        this.$bvToast.toast('El archivo supera el peso máximo de 5 MB.', {
          variant: 'danger',
        })
        return
      }
      this.file = candidate
      this.setBoleta(this.file)
    },
    handleFileUpload() {
      const candidate = this.$refs.file.files[0]
      this.applyFile(candidate)
    },
    onDrop(event) {
      const candidate = event.dataTransfer && event.dataTransfer.files[0]
      this.applyFile(candidate)
    },
    async submitFile() {
      if (!this.file) return
      if (
        this.file.type !== 'image/jpeg' &&
        this.file.type !== 'image/png' &&
        this.file.type !== 'application/pdf'
      ) {
        this.$bvToast.toast('Solo se permiten archivos .jpg, .png, .pdf ')
        return
      }
      this.setBoleta(this.file)
    },
  },
}
</script>
